import { CaretDownOutlined } from '@ant-design/icons'
import React, { useEffect, useRef, useState } from 'react'

// 기본 색상 10가지
const DEFAULT_COLORS = [
  '#FFC700',
  '#FF9500',
  '#F26F52',
  '#1BC47D',
  '#18A0FB',
  '#EE46D3',
  '#7A66FF',
  '#8F8F8F',
  '#FF6669',
  '#9D52F2',
]

const ColorDropDown = ({
  value,
  defaultValue,
  colors = DEFAULT_COLORS, // 컬러 배열 (기본값: DEFAULT_COLORS)
  onChange,
  disabled = false,
}) => {
  const [open, setOpen] = useState(false)
  const [internalColor, setInternalColor] = useState(
    defaultValue ?? colors[0] ?? DEFAULT_COLORS[0],
  )
  const wrapperRef = useRef(null)

  const selectedColor = value ?? internalColor

  // 외부 클릭 닫기
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleSelect = (color) => {
    if (value === undefined) {
      setInternalColor(color)
    }
    onChange?.(color)
    setOpen(false)
  }

  const displayColors = colors.length > 0 ? colors : DEFAULT_COLORS

  return (
    <div ref={wrapperRef} style={{ position: 'relative' }}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => setOpen((prev) => !prev)}
        style={{
          ...styles.selectedButton,
          opacity: disabled ? 0.5 : 1,
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      >
        <div
          style={{
            ...styles.colorCircle,
            background: selectedColor,
          }}
        />

        <CaretDownOutlined
          style={{
            fontSize: '14px',
            color: '#80807D',
            marginLeft: '6px',
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s',
          }}
        />
      </button>

      {open && !disabled && (
        <div style={styles.dropdown}>
          <div style={styles.colorGrid}>
            {displayColors.map((color, index) => (
              <button
                key={index}
                type="button"
                onClick={() => handleSelect(color)}
                style={{
                  ...styles.colorOption,
                  background: color,
                  border:
                    selectedColor === color
                      ? '2px solid #FFFFFF'
                      : '1px solid #E1E1DE',
                }}
                title={color}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default ColorDropDown

const styles = {
  selectedButton: {
    fontSize: '16px',
    cursor: 'pointer',
    background: 'transparent',
    border: '1px solid #E1E1DE',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '48px',
    padding: '0 12px',
    borderRadius: '8px',
  },
  dropdown: {
    position: 'absolute',
    top: '60px',
    zIndex: 9999,
    background: '#FFFFFF',
    border: '1px solid #E1E1DE',
    borderRadius: '8px',
    padding: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  },
  colorGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
    gap: '8px',
    minWidth: '200px',
  },
  colorCircle: {
    width: '28px',
    height: '28px',
    aspectRatio: '1/1',
    borderRadius: '6px',
    border: '1px solid #E1E1DE',
  },
  colorOption: {
    width: '32px',
    height: '32px',
    aspectRatio: '1/1',
    borderRadius: '6px',
    cursor: 'pointer',
    border: '1px solid #E1E1DE',
    padding: 0,
    transition: 'transform 0.2s',
  },
}
